import React from 'react';
import {
	Router,
	Route,
	Switch,
	Link
} from 'react-router-dom';

import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

import Axios from 'axios';
import moment from 'moment';

// Router: MASTER
import Admin_Master from './Admin_Master';
import LeaguesAdmin from './leagues/LeaguesAdmin';
import SeasonsAdmin from './leagues/SeasonsAdmin';
import AdminUsers from './adminUsers/users';
import UsersInvoiceDetails from './adminUsers/usersInvoiceDetails';
import MemberActiveUsers from './adminUsers/memberActiveUsers';
import UserEvents from './adminUsers/userEvents';
import AdminPubEvents from './pub/adminPubEvents';
import Connections from './connections/connections';
import EditUser from './adminUsers/editUser';
import AddLeague from './leagues/AddLeague';
import PlayersMerging from './players/PlayersMerging';

// Router Customers
import QvneaAdmin from './customers/QvneaAdmin';

// Router: Locations
import AdminLocations from './Admin_Locations'

// Router: Équipes
import TeamsAdmin from './teams/TeamsAdmin';
import TeamAdmin from './teams/TeamAdmin';

// Router: DEV
import Admin_Dev from './Admin_Dev';
import TestZone from './tests/TestZone';
import DevScripting from './tests/DevScripting';
import NewsletterMembers from './newsletter/NewsletterMembers';

// App
import * as myConstClass from '../shared/constants/constants';
import Users from '../users/Users';

// Refs:  React router and tabs
// https://github.com/reactstrap/reactstrap/issues/83#issue-168537815
// https://github.com/reactstrap/reactstrap/issues/298
// https://codesandbox.io/s/github/browniefed/tmp/tree/reactRouterDynamicRoutes/?from-embed
// https://stackoverflow.com/questions/51203888/reactjs-routing-to-different-tabs

// ADMIN MAINTENANCE SPECIAL CONSTANT
const ADMIN_MAINTENANCE_RESTRICTED_TO_MASTER = false;

const ADMIN_LVL_MASTER = 0;
const ADMIN_LVL_CHARTERS = 1;
const ADMIN_LVL_LEAGUES = 2;
const ADMIN_LVL_SEASONS = 3;
const ADMIN_LVL_SCORESHEETS = 10;
const ADMIN_LVL_ADMINLIMIT = 20;
const ADMIN_LVL_NOACCESS = 99;

class AdminGeneral extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			activeTabItem: '1',

			isAuthenticated: this.props.auth.isAuthenticated(),
			profile: this.props.auth.getProfile(),
			adminAccess: {
				auth: this.props.auth,
				globalAccessLevel: ADMIN_LVL_NOACCESS,
				adminValidatedAccessLevel: ADMIN_LVL_NOACCESS,
				charterAdmin: ''
			},
		};
	
		this.toggle = this.toggle.bind(this);
		this.getAdminRightsInfo = this.getAdminRightsInfo.bind(this);
	}

	componentDidMount() {
		//console.log('ADMIN_GENERAL: componentDidMount');
		//console.log(this.props)
		this.getAdminRightsInfo();
	}

	UNSAFE_componentWillReceiveProps(nextprops) {
		// console.log('ADMIN: UNSAFE_componentWillReceiveProps');
		// console.log(nextprops.location.pathname);
	}

	toggle(tab) {
		if (this.state.activeTabItem !== tab) {
			this.setState({
				activeTabItem: tab
			});
		}
	}

	render() {
		//console.log('Admin_General: render');
		//console.log('this.state.adminAccess.globalAccessLevel: ' + this.state.adminAccess.globalAccessLevel);
		//console.log('this.state.adminAccess.adminValidatedAccessLevel: ' + this.state.adminAccess.adminValidatedAccessLevel);
		//console.log('Admin_General this.props')
		//console.log(this.props)

		var bAdminLvl = this.state.adminAccess.globalAccessLevel;
		//console.log('bAdminLvl', bAdminLvl)

		// bAdminLvl = 3;	// force for tests
		return (
			<div>
				<div className="row row-align-items-flex-end">
					<div className="col-md-12 col-12 row-margin-bottom-20">
						<p>* Pour une utilisation optimale de Statelo en mode Administrateur, utiliser le navigateur Google Chrome que vous pouvez télécharger ici</p>
	        	<a href={'https://www.google.fr/intl/fr/chrome/'} target="_blank">
			        <input type="button" className="btn btn-primary btn-sm db-menu-padsides" value="Télécharger Google Chrome" />
	        	</a>
					</div>
				</div>

				{/* ----------------- TAB CONTAINER ---------------- */}
				<div className="row">
					<div className="col-md-12">
					<div className="card card-accent-success">
					<div className="card-block">
					<Nav tabs>

						{(bAdminLvl === ADMIN_LVL_MASTER) && <NavItem>
							<NavLink tag={Link} to="/admsafe/masteradmin"
								active={this.state.activeTabItem === '1'}
								onClick={() => { this.toggle('1'); }}>
								MASTER
							</NavLink>
						</NavItem>}

						{(bAdminLvl === ADMIN_LVL_MASTER) && <NavItem>
							<NavLink tag={Link} to="/admsafe/qvneaAdmin"
								active={this.state.activeTabItem === '2'}
								onClick={() => { this.toggle('2'); }}>
								QVNEA
							</NavLink>                        
						</NavItem>}

						{(bAdminLvl === ADMIN_LVL_MASTER) && <NavItem>
							<NavLink tag={Link} to="/admsafe/locations"
								active={this.state.activeTabItem === '3'}
								onClick={() => { this.toggle('3'); }}>
								Lieux
							</NavLink>                        
						</NavItem>}

						{(bAdminLvl === ADMIN_LVL_MASTER) && <NavItem>
							<NavLink tag={Link} to="/admsafe/teams"
								active={this.state.activeTabItem === '4'}
								onClick={() => { this.toggle('4'); }}>
								Équipes
							</NavLink>                        
						</NavItem>}

						{(bAdminLvl === ADMIN_LVL_MASTER) && <NavItem>
							<NavLink tag={Link} to="/admsafe/dev"
								active={this.state.activeTabItem === '5'}
								onClick={() => { this.toggle('5'); }}>
								DEV
							</NavLink>
						</NavItem>}
					</Nav>

					{/* ----------------- TAB CONTENT - ROUTER ---------------- */}
					<TabContent activeTab="1">
					<TabPane tabId="1">
						<Switch>

							{/* Routes: MASTER */}
							<Route path="/admsafe/masteradmin" component={Admin_Master}/>
							<Route exact path="/admsafe/leagues" component={LeaguesAdmin}/>
							<Route path="/admsafe/seasons" component={SeasonsAdmin}/>
							<Route exact path="/admsafe/users" component={AdminUsers} />
							<Route path="/admsafe/users/:userid" component={EditUser} />
							<Route path="/admsafe/UsersInvoiceDetails" component={UsersInvoiceDetails} />
							<Route path="/admsafe/memberActiveUsers" component={MemberActiveUsers} />
							<Route path="/admsafe/userEvents" component={UserEvents} />
							<Route path="/admsafe/adminPubEvents" component={AdminPubEvents} />
							<Route path="/admsafe/connections" component={Connections} />
							<Route path="/admsafe/leagues/add" exact render={(props) => 
								<AddLeague history={this.props.history} reloadLeagues={this.loadLeagues} />} />
							<Route exact path="/admsafe/mergePlayers" component={PlayersMerging}/>

							{/* Routes: Customers */}
							<Route path="/admsafe/qvneaAdmin" render={(props) => 
								<QvneaAdmin history={this.props.history} adminAccess={this.state.adminAccess} />} />

							{/* Routes: Locations */}
							<Route exact path="/admsafe/locations" render={(props) => 
								<AdminLocations	adminAccess={this.state.adminAccess} />} />

							{/* Routes: Équipes */}
							<Route exact path="/admsafe/teams" component={TeamsAdmin}/>
							<Route path="/admsafe/teams/:teid" component={TeamAdmin} />

							{/* Routes: DEV */}
							<Route path="/admsafe/dev" component={Admin_Dev} />
							<Route path="/admsafe/NewsletterMembers" component={NewsletterMembers} />
							<Route path="/admsafe/testzone" component={TestZone} />
							<Route path="/admsafe/DevScripting" component={DevScripting} />

						</Switch>
					</TabPane>
					</TabContent>
				</div>
				</div> 
				</div>
				</div>
				<br/>
			</div>
		)
	}

	getAdminRightsInfo() {

		// console.log('Admin: getAdminRightsInfo');
		var _this = this;
		var charterId = 0;  // temp
		var adminAccess = this.state.adminAccess;

		if (this.state.isAuthenticated) {
			Users.getAccessLevel(_this.state.profile, function(globalAccessLevel) {
			Users.getValidateAccessLevel(_this.state.profile, charterId, '0', '0', function(validatedAccessLevel) {
			Users.getCharterAdmin(_this.state.profile, function(charterAdmin) {

				// console.log('Admin: setState: getAdminRightsInfo');
				// console.log(adminAccess);
				adminAccess.globalAccessLevel = globalAccessLevel;
				adminAccess.adminValidatedAccessLevel = validatedAccessLevel;
				adminAccess.charterAdmin = charterAdmin;

				_this.setState({
					adminAccess: adminAccess
				});
			});
			});
			});

		} else {
			adminAccess.globalAccessLevel = ADMIN_LVL_NOACCESS;
			adminAccess.adminValidatedAccessLevel = ADMIN_LVL_NOACCESS;
			adminAccess.charterAdmin = '';
			this.setState({
				adminAccess: adminAccess
			});
		}
	}

};

export default AdminGeneral;
